import React, { useState } from "react";
import { galleryImages } from "../data/gallery";
import { X, ZoomIn } from "lucide-react";

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="bg-white text-neutral-900 min-h-screen">
      {/* Page Header */}
      <section className="bg-black text-white py-16 border-b border-neutral-900 text-center relative overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src="https://assets.auxodev.dk/assets/0fa1183b-3f51-46de-aff6-df593e862933/23fa2a6a-f483-405b-bd63-5414a9cb56c5.jpg"
            alt="Galleri baggrund"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-neutral-400 block mb-2">
            Billeder fra butikken
          </span>
          <h1 className="text-4xl md:text-5xl font-serif font-bold tracking-tight">
            Vores Galleri
          </h1>
          <p className="text-sm text-neutral-400 max-w-lg mx-auto leading-relaxed">
            Tag et kig på vores lækre udvalg af frisksmurt smørrebrød, sandwich, platter og festanretninger. Alt er lavet med kærlighed og friske råvarer.
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {galleryImages.map((image, idx) => (
            <div
              key={idx}
              className="group relative cursor-pointer overflow-hidden transition-all duration-300"
              onClick={() => setSelectedImage(image)}
            >
              <div className="relative h-72 overflow-hidden">
                <img
                  src={image.url}
                  alt="Galleri billede"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 animate-fadeIn"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-6 right-6 text-white hover:text-neutral-300 p-2 focus:outline-none"
            onClick={() => setSelectedImage(null)}
          >
            <X size={32} />
          </button>
          <div
            className="max-w-4xl w-full max-h-[85vh] flex flex-col items-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage.url}
              alt="Galleri billede"
              className="max-w-full max-h-[85vh] object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
}
